import data from '@emoji-mart/data';
import Picker from '@emoji-mart/react';
import { FC, useEffect, useRef } from 'react';

interface EmojiSelectorProps {
	command: (...args: any[]) => void;
}

export const EmojiSelector: FC<EmojiSelectorProps> = ({ command }) => {
	const containerRef = useRef<HTMLDivElement>(null);

	useEffect(() => {
		// Focus the search input without scrolling the page
		// emoji-mart uses shadow DOM, so we need to access the shadow root
		requestAnimationFrame(() => {
			const picker = containerRef.current?.querySelector('em-emoji-picker');
			const shadowRoot = picker?.shadowRoot;
			const searchInput = shadowRoot?.querySelector('input[type="search"]');
			if (searchInput instanceof HTMLInputElement) {
				searchInput.focus({ preventScroll: true });
			}
		});
	}, []);

	const handleSelect = ({ native }: any) => {
		command({ id: native });
	};

	return (
		<div ref={containerRef}>
			<Picker data={data} onEmojiSelect={handleSelect} />
		</div>
	);
};
